 // Utility function to convert miles to meters
 export const milesToMeters = (miles) => miles * 1609.34;
export const metersToMiles = (meters) => meters / 1609.34; // 1 mile ≈ 1609.34 meters